var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.images.length >= 2
    ? _c("div", { staticClass: "image-grid-container" }, [
        _c("div", { staticClass: "container" }, [
          _vm.header
            ? _c("div", { staticClass: "image-grid__header-content" }, [
                _c("div", { staticClass: "image-grid__header h3" }, [
                  _vm._v(_vm._s(_vm.header))
                ]),
                _vm.header_link_text && _vm.header_link_url
                  ? _c(
                      "a",
                      {
                        staticClass: "link link--primary",
                        attrs: { href: _vm.header_link_url }
                      },
                      [
                        _c("span", { staticClass: "link__content" }, [
                          _vm._v(_vm._s(_vm.header_link_text))
                        ]),
                        _c("icon", {
                          attrs: { name: "arrow_long_right", size: "20px" }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "image-grid", class: _vm.gridClass },
            _vm._l(_vm.validImages, function(image, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "image-grid-item",
                  class: { "image-grid-item--main": _vm.isMainGridItem(index) },
                  style: { "background-image": "url(" + image.image + ")" }
                },
                [
                  _c("div", {
                    staticClass: "image-grid-item__overlay",
                    class: {
                      "bg-black": image.overlay_color === "dark",
                      "bg-white": image.overlay_color === "light"
                    },
                    style: {
                      opacity: image.overlay_opacity
                        ? image.overlay_opacity / 100
                        : 0.5
                    }
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "image-grid-item__content",
                      class: {
                        "color-black": image.text_color === "dark",
                        "color-white": image.text_color === "light"
                      }
                    },
                    [
                      image.preheader
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "image-grid-item__preheader preheader"
                            },
                            [_vm._v(_vm._s(image.preheader))]
                          )
                        : _vm._e(),
                      image.header
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "image-grid-item__header h4-mobile h5-tablet-up"
                            },
                            [_vm._v(_vm._s(image.header))]
                          )
                        : _vm._e(),
                      image.text
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "image-grid-item__text body-md u-hidden-mobile-only"
                            },
                            [_vm._v(_vm._s(image.text))]
                          )
                        : _vm._e(),
                      image.cta_text && image.cta_link
                        ? _c(
                            "a",
                            {
                              staticClass: "button image-grid-item__cta",
                              class: _vm.buttonClass,
                              attrs: { href: image.cta_link }
                            },
                            [
                              _c("span", { staticClass: "button__content" }, [
                                _vm._v(_vm._s(image.cta_text))
                              ])
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ]
              )
            }),
            0
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }